{
  "header": {
    "appName": "Bennie",
    "workspaces": "Espaces de travail",
    "projects": "Projets",
    "analytics": "Analyses",
    "reggie": "Banc d'essai",
    "settings": "Paramètres",
    "signOut": "Se déconnecter",
    "home": "Accueil",
    "ariaLogo": "Kyronyx",
    "tooltipAccount": "Compte",
    "userPlaceholder": "Utilisateur",
    "notSignedIn": "Non connecté",
    "signedIn": "Connecté",
    "administrator": "Administrateur",
    "signIn": "Se connecter",
    "profile": "Profil",
    "models": "Modèles",
    "dashboard": "Tableau de bord"
  },
  "rail": {
    "navLabel": "Navigation principale",
    "modelLinksLabel": "Sections du modèle",
    "trailLabel": "Fil d’Ariane"
  },
  "breadcrumb": {
    "workspaces": "Espaces de travail",
    "workspace": "Espace de travail",
    "plan": "Plan",
    "report": "Rapport",
    "files": "Fichiers"
  },
  "tabs": {
    "data": "Données",
    "plan": "Plan",
    "report": "Rapport",
    "settings": "Paramètres"
  },
  "userMenu": {
    "settings": "Paramètres",
    "signOut": "Se déconnecter"
  },
  "serviceSelection": {
    "comingSoonAppend": "{{description}} — Non disponible",
    "continue": "Continuer",
    "selectServiceType": "Sélectionner le type de service",
    "genericTaskTitle": "Tâche générique",
    "genericTaskDescription": "Ignorer la sélection du service. Importez des documents directement et générez un rapport personnalisé.",
    "availabilityWarning": "La disponibilité des services n'a pas pu être vérifiée. Toutes les catégories sont affichées — certaines peuvent ne pas avoir de connaissances curées chargées.",
    "serviceTypes": {
      "validation": "Validation",
      "auditing": "Audit",
      "development": "Développement"
    }
  }
}
